export { default } from './PopularBodyStyles';
